module.exports = __webpack_public_path__ + "static/img/1.738d4655.jpg";